import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql } from 'gatsby';
import BlockContent from '@sanity/block-content-to-react';

import { RawPortableText, GatsbySanityImageFluidNoBase64 } from '../types';
import SEO from '../components/SEO';
import DetailsPageLayout from '../components/DetailsPageLayout';
import serializers from '../serializers';
// import ArticlesPagination from '../components/ArticlesPagination';

import * as styles from './NewsArticlePage.module.scss';

interface NewsArticlePageProps {
  data: {
    sanityNewsArticle: {
      image?: {
        asset?: {
          url: string;
          fluid: GatsbySanityImageFluidNoBase64;
        };
      };
      slug: {
        current: string;
      };
      title: string;
      date: string;
      categories: Array<{
        title: string;
      }>;
      extract: string;
      _rawBody: RawPortableText;
    };
  };
}

export const query = graphql`
  # -444f41d0-18e2-55db-8fca-44fd6229a7e8
  query GetNewsArticleById($id: String!) {
    sanityNewsArticle(id: { eq: $id }) {
      image {
        asset {
          url
          fluid(maxWidth: 1100, maxHeight: 500) {
            ...GatsbySanityImageFluid_noBase64
          }
        }
      }
      slug {
        current
      }
      title
      date
      categories {
        title
      }
      extract
      # TODO Find a way to avoid using maxDepth
      _rawBody(resolveReferences: { maxDepth: 6 })
    }
  }
`;

const NewsArticlePage = ({ data }: NewsArticlePageProps): React.ReactElement => {
  const { sanityNewsArticle: newsArticle } = data;
  const { t } = useTranslation();

  return (
    <DetailsPageLayout
      withShareLink
      turnBackLink={{ to: '/news/', title: t('news_article_page_return_link', 'All news') }}
      imageFluid={newsArticle.image && newsArticle.image.asset && newsArticle.image.asset.fluid}
      imageAlt={newsArticle.title}
      title={newsArticle.title}
      date={newsArticle.date}
      categories={newsArticle.categories}
    >
      <SEO
        title={newsArticle.title}
        description={newsArticle.extract}
        urlPath={'/news/' + newsArticle.slug.current}
        imageUrl={
          newsArticle.image && newsArticle.image.asset
            ? newsArticle.image.asset.url + '?w=1200&h=630&fit=min'
            : undefined
        }
      />
      <BlockContent
        className={styles.body}
        blocks={newsArticle._rawBody}
        serializers={serializers}
      />
      {/* <ArticlesPagination>{entries}</ArticlesPagination> */}
    </DetailsPageLayout>
  );
};

export default NewsArticlePage;
